module.exports = __webpack_public_path__ + "img/no-urls-activity.79759028.png";